import API from '@aws-amplify/api';
import Constant from '@/common/constant/Constant';
import Utils from '@/common/utils/utils';
import { getChatThreadList } from '@/graphql/queries';
import { updateChatThread } from '@/graphql/mutations';
import {getTicketById} from './ticketService'
import _ from 'lodash';
import { getExpressionQueryChatThreadByTicketId } from './dynamoDBRequestDto/DynamoDBChatThreadRequestDto';
import TelephoneConstant from '@/common/constant/TelephoneConstant';

export const getListChatThreadByTicket = async (
    APIClient,
    ticket,
    corporationId,
    projectId,
    userId,
    exChangeTicket,
    panelType
) => {
    try {
        let listTicketId = [];
        let ticketDetail;
        if (exChangeTicket) {
            ticketDetail = await getTicketById(API, ticket.id);
        } else {
            ticketDetail = ticket;
        }
        listTicketId.push(ticketDetail.id);

        if (
            ticketDetail.ticketType === Constant.TICKET_TYPE.BROADCAST_CHILD ||
            ticketDetail.ticketType === Constant.TICKET_TYPE.BROADCAST_PARENT ||
            (
                ticketDetail.ticketType === Constant.TICKET_TYPE.TELEPHONE &&
                Utils.defineVoiceCallFlow(ticketDetail?.metaData) === TelephoneConstant.VOICE_CALL_FLOW.PROJECT_TO_PROJECT
            )
        ) {
            if (!Utils.isEmptyArray(ticketDetail.child)) {
                let ticketChild = ticketDetail.child;
                listTicketId = listTicketId.concat(ticketChild);
            }
            if (!Utils.isEmptyString(ticketDetail.parent)) {
                listTicketId.push(ticketDetail.parent);
            }
        } else {
            if (
                !Utils.isEmptyArray(
                    Utils.convertJSONDataToObject(ticketDetail.inhouseCollaboratorTicketId)
                )
            ) {
                Utils.convertJSONDataToObject(ticketDetail.inhouseCollaboratorTicketId)?.forEach(
                    ticketId => {
                        listTicketId.push(ticketId);
                    }
                );
            }
            if (
                !Utils.isEmptyArray(
                    Utils.convertJSONDataToObject(ticketDetail.externalCollaboratorTicketId)
                )
            ) {
                Utils.convertJSONDataToObject(ticketDetail.externalCollaboratorTicketId)?.forEach(
                    ticketId => {
                        listTicketId.push(ticketId);
                    }
                );
            }
            if (ticketDetail?.inhouseCustomerTicketId || ticketDetail?.externalCustomerTicketId) {
                const parentTicketId = ticketDetail?.inhouseCustomerTicketId
                    ? ticketDetail?.inhouseCustomerTicketId
                    : ticketDetail?.externalCustomerTicketId;
                listTicketId.push(parentTicketId);
            }
        }

        //get list thread by list ticketId
        const queryResult = await Promise.all(
            listTicketId.map(ticketId => {
                const dynamodbExpression = getExpressionQueryChatThreadByTicketId(ticketId);
                return API.graphql({
                    query: getChatThreadList,
                    variables: {
                        params: {
                            expression: JSON.stringify(dynamodbExpression)
                        }
                    }
                    // authMode: Constant.AUTH_MODE_API_KEY,
                });
            })
        );

        let listThreadResult = [];
        for (let i = 0; i < queryResult.length; i++) {
            let res = queryResult[i];
            if (!Utils.isEmptyArray(res.data.getChatThreadList)) {
                listThreadResult = listThreadResult.concat(res.data.getChatThreadList);
            }
        }
        let listThreadFilter = _.filter(listThreadResult, function(t) {
            if( t.threadType === Constant.THREAD_TYPE.AI_ASSISTANT){
                return ticketDetail.affiliationProject === projectId && ticketDetail.id === t.ticketId
            }
           
            if (Utils.isValidJSONString(t.sharedRange)) {
                if (ticket.id === t.ticketId && t.threadType === Constant.THREAD_TYPE.INTERNAL && ticket.ticketType === Constant.TICKET_TYPE.TASK && ticket.affiliationProject === projectId) {
                    return true;
                }

                if (panelType === Constant.PANEL_TYPE.CUSTOMER_CHATTHREAD && 
                    t.threadType === Constant.THREAD_TYPE.INTERNAL && 
                    ticket.id !== t.ticketId
                ) {
                    return false;
                }

                // if (panelType === Constant.PANEL_TYPE.CUSTOMER_CHATTHREAD && 
                //     t.threadType === Constant.THREAD_TYPE.INTERNAL && 
                //     ticket.id !== t.ticketId
                // ) {
                //     return false;
                // }

                let sharedRange = JSON.parse(t.sharedRange);
                if (typeof sharedRange[corporationId] !== 'undefined') {
                    
                    if (typeof sharedRange[corporationId][projectId] !== 'undefined') {
                        if (sharedRange[corporationId][projectId].includes(ticket.id)) {
                            return sharedRange[corporationId][projectId].includes(ticket.id);
                        }
                    }
                }
                if (
                    typeof sharedRange[corporationId] !== 'undefined' &&
                    typeof sharedRange[corporationId][userId] !== 'undefined'
                ) {
                    if (sharedRange[corporationId][userId].includes(ticket.id)) {
                        return sharedRange[corporationId][userId].includes(ticket.id);
                    }
                }
            }
            return false;
        });

        return Utils.sortByCreatedAtAsc(listThreadFilter);
    } catch (err) {
        console.log('Utils.sortByCreatedAtAsc(listThreadFilter) :>> ', err);
    }
};

export const getListChatThreadByTicketId = async (APIClient, ticketId) => {
    try {
        const dynamodbExpression = getExpressionQueryChatThreadByTicketId(ticketId);
        let res = await API.graphql({
            query: getChatThreadList,
            variables: {
                params: {
                    expression: JSON.stringify(dynamodbExpression)
                }
            }
        });

        return res.data?.getChatThreadList ? res.data.getChatThreadList : [];
    } catch (err) {
        return [];
    }
};

export const getListChatThreadForTicketKnowledge = async (APIClient, ticket) => {
    if (Utils.isEmptyObject(ticket)) {
        return [];
    }
    let listThread = await getListChatThreadByTicketId(API, ticket.id);

    return listThread;
};

export const updateChatThreadInfo = async (requestDto) => {
    if (Utils.isEmptyObject(requestDto) || Utils.isEmptyString(requestDto?.id)) return null;

    try {
        const result = await API.graphql({
            query: updateChatThread,
            variables: {
                input: {
                    id: requestDto.id,
                    aiAssistantStatus: requestDto.aiAssistantStatus,
                    aiAssistantStatusUpdatedAt: requestDto.aiAssistantStatusUpdatedAt,
                },
            },
        });

        return result?.data?.updateChatThread || null;
    } catch (err) {
        console.log('updateChatThreadInfo err:', err);
        return null;
    }
};
